export default abstract class SnapshotListener {
  protected _unsubscribe?: () => void

  public unsubscribe(): void {
    this._unsubscribe?.()
  }
}
